import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const DispatchSettingsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--dispatch']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
